export default function env() {
    return {
        'protocol': 'http',
        'dns'     : 'cv.barbares.co'
    };
}